module.exports = __webpack_public_path__ + "media/stylesheets/images/sareye_white-1b02ebbb01daf36e190c972b13cb0400.svg";